// extracted by mini-css-extract-plugin
export default {"root":"qWcIPI9Vbw","list":"uw9bg2G0Tq"};